import React from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';

const FiltersPartial = (props) => {
    const { filtersModel, setFiltersModel } = props;

    const onBranchSelect = (selectedItems, selectedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, branch_ids: [...(prevState.branch_ids || []), selectedOption.id] }
        })
    }

    const onBranchRemove = (selectedItems, removedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, branch_ids: prevState.branch_ids.filter((id) => id !== removedOption.id) }
        })
    }

    const onVehicleTypeSelect = (selectedItems, selectedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, vehicle_type_ids: [...(prevState.vehicle_type_ids || []), selectedOption.id] }
        })
    }

    const onVehicleTypeRemove = (selectedItems, removedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, vehicle_type_ids: prevState.vehicle_type_ids.filter((id) => id !== removedOption.id) }
        })
    }

    return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
        <div>
            <Form.Group className="mb-3">
                <Form.Label>Circle</Form.Label>
                <MultiSelectField
                    options={[]}
                    fieldName="branch_ids"
                    stateModel={filtersModel}
                    dynamicOptions={{
                        dependsOnFields: [],
                        apiName: "branches",
                        dataAttr: "branches",
                    }}
                    labelAttr="name"
                    valueAttr="id"
                    displayValue="name"
                    onSelect={onBranchSelect}
                    onRemove={onBranchRemove}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Vehicle Type</Form.Label>
                <MultiSelectField
                    options={[]}
                    fieldName="vehicle_type_ids"
                    stateModel={filtersModel}
                    dynamicOptions={{
                        dependsOnFields: [],
                        apiName: "vehicleTypes",
                        dataAttr: "vehicle_types",
                    }}
                    labelAttr="type"
                    valueAttr="id"
                    displayValue="type"
                    onSelect={onVehicleTypeSelect}
                    onRemove={onVehicleTypeRemove}
                />
            </Form.Group>
        </div>
    </Filters>
};

export default FiltersPartial;

